import { registerComponent } from 'lib/react_on_rails';

import { CloudflareTurnstile } from 'components/cloudflare_turnstile';

registerComponent('CloudflareTurnstile', CloudflareTurnstile);
